




















































































































































































































































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import STextarea from '@/common/components/STextareaShort.vue';
import TableInput from '@/tasks/components/inputs/TableInput.vue';
import FileUploadUiComponent from '@/tasks/components/task-ui-components/FileUploadUiComponent.vue';
import ChemicalNotationInput from '@/chemical-equations/components/ChemicalNotationInput.vue';

export default defineComponent({
  name: 'McMaster_Chem2OA3_Lab3_ReportSheet',
  components: {
    ChemicalNotationInput,
    FileUploadUiComponent,
    TableInput,
    STextarea,
    CalculationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        dyeA: null,
        dyeB: null,
        dyeC: null,

        dyeApH0: null,
        dyeApH7: null,
        dyeApH14: null,
        dyeBpH0: null,
        dyeBpH7: null,
        dyeBpH14: null,
        dyeCpH0: null,
        dyeCpH7: null,
        dyeCpH14: null,

        observations: null,
        discussion: null,
        conclusion: null,
      },
      dyeOptions: [
        {text: 'Solvent Blue 59', value: 'Solvent Blue 59'},
        {text: 'Solvent Red 19', value: 'Solvent Red 19'},
        {text: 'Methylene Blue', value: 'Methylene Blue'},
        {text: 'Direct Red 81', value: 'Direct Red 81'},
        {text: 'Disperse Blue 35', value: 'Disperse Blue 35'},
        {text: 'Sudan Orange', value: 'Sudan Orange'},
        {text: 'Nile Blue A', value: 'Nile Blue A'},
        {text: 'Disperse Red 1', value: 'Disperse Red 1'},
      ],
      reactions: [] as File[],
    };
  },
  computed: {
    attachments(): File[] {
      return [...this.reactions];
    },
  },
});
